import {
  Contact,
  Entity,
  Task,
  CreateTaskInput,
  DocumentAnalysis,
} from '@admiin-com/ds-graphql';
import { TaskCreationProvider } from '../../features/providers/TaskCreationProvider/TaskCreationProvider';
import TaskCreatModal from './TaskCreateModal';
import { TaskCreateType } from '../../features/components/CreateTaskButtonGroup/CreateTaskButtonGroup';

export type TaskCreateModalProps = {
  open: boolean;
  onClose: () => void;
  task?: Task | null;
  taskType?: TaskCreateType;
  client?: Entity;
  contact?: Contact;
  onSuccess?: (task: CreateTaskInput) => void;
  documentAnalysis?: DocumentAnalysis | null;
};

function TaskCreatModalContainer(props: TaskCreateModalProps) {
  return (
    <TaskCreationProvider
      task={props.task}
      onClose={props.onClose}
      client={props.client}
      taskType={props.taskType}
      contact={props.contact}
      documentAnalysis={props.documentAnalysis}
    >
      <TaskCreatModal {...props} />
    </TaskCreationProvider>
  );
}
export default TaskCreatModalContainer;
